module.exports = __webpack_public_path__ + "media/cuttlefish/community-content-lrg-b446b324.svg";